// extracted by mini-css-extract-plugin
export var contentText = "resources-module--contentText--b5eb7";
export var exploreBtn = "resources-module--exploreBtn--d6425";
export var mainListDiv = "resources-module--mainListDiv--d2714";
export var smallTitle = "resources-module--smallTitle--cfa53";
export var ulList = "resources-module--ulList--5c728";